import React, { useEffect, useState } from 'react'
import axios from 'axios'
import "../styles/AdminApplications.css"
import Pagination from '@material-ui/lab/Pagination';
import { upperFirst } from 'lodash'
import { useDispatch } from 'react-redux'
import { ApiURL } from '../constants/ApiUrl'
import { useHistory } from 'react-router-dom'
import * as Yup from "yup"
import { LinearProgress, TextField, TextareaAutosize, Select, MenuItem, InputLabel, FormControl, FormHelperText, Button } from '@material-ui/core'
import "../styles/FormPage1.css"

function MemberKit() {

 const getUpdateUrl = (url)=>{

    console.log("Updating image url 7777777777777777777777777777777777777777");
  
    const oldDomain = "nmobucket.s3.ap-south-1.amazonaws.com";
  const newDomain = "pub-5e98b3129b274a77aa3ee9286a182644.r2.dev";

  return url.replace(oldDomain, newDomain);

  }

    return (
        <>
            <h1>Documents For Download</h1>
            <div className="admkit">
                <div style={{ textAlign: 'center', padding: '0 0 50px 0' }}>
                    {/* <h1>Documents For Download</h1> */}
                    <div className="applicationContainer" style={{ margin: "auto" }}>
                        <table style={{ width: "700px" }} className="applicationTable">
                            <tr>
                                <td>NMO Brochure</td>
                                <td> <a href={getUpdateUrl("https://nmobucket.s3.ap-south-1.amazonaws.com/3.NMO+final+brouchure.pdf")} target="_blank">Download</a></td>
                            </tr>
                            <tr>
                                <td>NMO Membership Kit</td>
                                <td> <a href={getUpdateUrl("https://nmobucket.s3.ap-south-1.amazonaws.com/5.NMO+Membership+Kit.pdf")} target="_blank">Download</a></td>
                            </tr>
                            <tr>
                                <td>Lord Dhanvantri Picture</td>
                                <td><a href={getUpdateUrl("https://nmobucket.s3.ap-south-1.amazonaws.com/6.Bhagvan+Dhanwantari+ji.jpg")} target="_blank">Download</a></td>
                            </tr>
                            <tr>
                                <td>Bharat Mata</td>
                                <td><a href={getUpdateUrl("https://nmobucket.s3.ap-south-1.amazonaws.com/7.Bharat+Mata.jpg")} target="_blank">Download</a></td>
                            </tr>
                            <tr>
                                <td>Swami Vivekanand Image</td>
                                <td><a href={getUpdateUrl("https://nmobucket.s3.ap-south-1.amazonaws.com/8.+Swami+Vivekananad+ji.jpg")} target="_blank">Download</a></td>
                            </tr>
                            <tr>
                                <td>NMO Logo(JPG)</td>
                                <td><a href={getUpdateUrl("https://nmobucket.s3.ap-south-1.amazonaws.com/9.NMO+Logo.jpg")} target="_blank">Download</a></td>
                            </tr>
                            <tr>
                                <td>NMO Logo(PDF)</td>
                                <td><a href={getUpdateUrl("https://nmobucket.s3.ap-south-1.amazonaws.com/9.NMO+Logo.jpg")} target="_blank">Download</a></td>
                            </tr>
                            <tr>
                                <td>Swastik Sticker(JPG)</td>
                                <td><a href={getUpdateUrl("https://nmobucket.s3.ap-south-1.amazonaws.com/11.Swastik+Logo.jpg")} target="_blank">Download</a></td>
                            </tr>
                            <tr>
                                <td>Swastik Sticker(PDF)</td>
                                <td><a href={getUpdateUrl("https://nmobucket.s3.ap-south-1.amazonaws.com/12.Swastik+Logo.pdf")} target="_blank">Download</a></td>
                            </tr>

                            {/* 
                        <tr>
                            <td>Charak Shapath(English)</td>
                            <td><a href="https://nmobucket.s3.ap-south-1.amazonaws.com/CHARAK+SAPATH+ENGLISH.pdf" target="_blank">Download</a></td>
                        </tr>
                       
                        <tr>
                            <td>NMO Geet</td>
                            <td> <a href="https://nmobucket.s3.ap-south-1.amazonaws.com/NMO+GEET.pdf" target="_blank">Download</a></td>
                        </tr>
                        
                        <tr>
                            <td>NMO Mantra</td>
                            <td><a href="https://nmobucket.s3.ap-south-1.amazonaws.com/NMO+MANTRA.pdf" target="_blank">Download</a></td>
                        </tr>
                       
                        <tr>
                            <td>Vande Matram</td>
                            <td><a href="https://nmobucket.s3.ap-south-1.amazonaws.com/VANDE+MATRAM.pdf" target="_blank">Download</a></td>
                        </tr>
                        
                        */}


                        </table>
                    </div>
                </div>

            </div>



        </>
    )
}


export default MemberKit;
